/**
 * True when an API error is a plan-tier gate (e.g. SCIM/SSO are Enterprise-only)
 * rather than a generic failure — so the UI can show an upgrade CTA instead of
 * a raw error string. Matches a 403 whose message mentions the plan/tier.
 */
export function isPlanGateError(err: unknown): boolean {
  const e = err as { response?: { status?: number; data?: { message?: string } }; message?: string };
  const status = e?.response?.status;
  const msg = (e?.response?.data?.message ?? e?.message ?? '').toLowerCase();
  const mentionsPlan = /plan|enterprise|tier|upgrade/.test(msg);
  return status === 403 && mentionsPlan;
}
